import { adminCustomersFeatureFlagsPostSlice } from './post';

export const {
	requestPostAdminCustomersFeatureFlags,
	resetPostAdminCustomersFeatureFlags
} = adminCustomersFeatureFlagsPostSlice.asyncActionCreators;
